import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { WorkItem } from '../work-item'
import { WorkItemContentComponent } from '../work-item-content/work-item-content.component'
import { MatToolbar } from '@angular/material/toolbar'
import { MatIcon } from '@angular/material/icon'
import { ElderHeaderComponent, ElderThemeDirective } from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { MatIconButton } from '@angular/material/button'

export interface IWorkItemDetailDialogOptions {
  readonly item: WorkItem
}

@Component({
  selector: 'app-work-item-content-dialog',
  templateUrl: './work-item-detail-dialog.component.html',
  styleUrls: ['./work-item-detail-dialog.component.scss'],
  imports: [
    MatToolbar,
    MatIcon,
    MatIconButton,
    ElderTranslatePipe,
    ElderThemeDirective,
    ElderHeaderComponent,
    WorkItemContentComponent,
  ],
})
export class WorkItemDetailDialogComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly item: WorkItem
  private dialogRef = inject<MatDialogRef<WorkItemDetailDialogComponent>>(MatDialogRef)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const data = inject<IWorkItemDetailDialogOptions>(MAT_DIALOG_DATA)
    this.item = data.item
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public close(): void {
    this.dialogRef.close()
  }
}
